var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27.5,
    r: 27,
    fill: "#F3633D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.989 35.5384C24.9151 35.5384 24.0329 34.6903 23.9906 33.6172L23.2226 14.1504C23.1779 13.0158 24.0856 12.0715 25.2211 12.0715H28.7436C29.8791 12.0715 30.7868 13.0158 30.742 14.1504L29.9741 33.6172C29.9318 34.6903 29.0496 35.5384 27.9757 35.5384H25.989ZM25.4183 45.8601C24.3138 45.8601 23.4183 44.9647 23.4183 43.8601V41.2413C23.4183 40.1367 24.3138 39.2413 25.4183 39.2413H28.5463C29.6509 39.2413 30.5463 40.1367 30.5463 41.2413V43.8601C30.5463 44.9647 29.6509 45.8601 28.5463 45.8601H25.4183Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.285e059908ae713d6880aa2066dbf85f.svg";
export { ForwardRef as ReactComponent };